

const listeners:Object={}
export function onEvent(event, callback) {
    if (!listeners[event]) {
      listeners[event] = [];
    }
    listeners[event].push(callback);
  }
export function offEvent(event){
    delete listeners[event];
  }

export function emitEvent(event, ...args) {
    if (listeners[event]) {
      listeners[event].forEach(listener => listener(...args));
    }
  }
